import React, { useRef, useState } from "react";
import { Button } from "reactstrap";
import { AwsS3Uploader } from "./AwsS3Uploader";
import appConfig from "config";

const defaultUploader = new AwsS3Uploader({
  accessKey: appConfig.s3.accessKey,
  secretKey: appConfig.s3.secretKey,
  bucket: appConfig.s3.bucket,
  region: appConfig.s3.region,
  endpoint: appConfig.s3.endpoint || undefined,
});

export interface S3FileUploadProps {
  serviceName: string;
  onSuccess: (fileUrl: string) => void;
  onError?: (message: string) => void;
  accept?: string;
  contentType?: string;
  buttonLabel?: string;
  disabled?: boolean;
  uploader?: AwsS3Uploader;
}

export const S3FileUpload: React.FC<S3FileUploadProps> = ({
  serviceName,
  onSuccess,
  onError,
  accept = ".xlsx,.xls",
  contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  buttonLabel = "Upload Excel",
  disabled = false,
  uploader = defaultUploader,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    if (onError) onError("");

    try {
      const url = await uploader.uploadFile(file, {
        serviceName,
        contentType,
      });
      if (url) {
        onSuccess(url);
      } else {
        onError?.("Upload failed.");
      }
    } catch {
      onError?.("Upload failed.");
    } finally {
      setUploading(false);
      e.target.value = "";
      inputRef.current?.form?.reset();
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        disabled={disabled || uploading}
        style={{ display: "none" }}
      />
      <Button
        color="primary"
        disabled={disabled || uploading}
        onClick={() => inputRef.current?.click()}
      >
        {uploading ? "Uploading..." : buttonLabel}
      </Button>
    </>
  );
};
